/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import PcModelOptionsSubGroupLists from 'containers/PcModel/PcModelOptionsSubGroupLists';
import PcModelOptionsSubGroupTabs from 'containers/PcModel/PcModelOptionsSubGroupTabs';
import { CommaArrayParam } from 'helpers/CommaArrayParam';
import { getGroupInfo } from 'helpers/getGroupInfo';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { JsonParam, useQueryParam, withDefault } from 'use-query-params';
import PcModelDelayAlert from '../PcModelDelayAlert';
import PcModelOptionImage from '../PcModelOptionImage';
import PcModelOptionImageWithModal from '../PcModelOptionImageWithModal';
import ValidationAlert from '../PcModelValidationAlert';
import styles from './styles';
import useScreenWidth from 'utils/useScreenWidth';

const PcModelOptionsGroup = ({
  pcModel,
  errors,
  allSubGroups,
  groupType,
  options,
  modelTheme,
}) => {
  const groupInfo = getGroupInfo(pcModel, groupType);

  const baseOption = options.find(
    (option) => option.group_type === groupType && option.is_base,
  );

  if (!baseOption) return null;

  const [completed, setCompleted] = useQueryParam(
    'completed',
    withDefault(CommaArrayParam, []),
  );

  const widthSize = useScreenWidth();
  let isExpanded;

  if (widthSize <= 500 && widthSize != null) {
    //MOBILE
    if (modelTheme.toggle_components_mobile) {
      if (!completed.includes(groupType)) {
        isExpanded = modelTheme.toggle_components_mobile;
      }
    } else {
      if (completed.includes(groupType)) {
        isExpanded = completed.includes(groupType);
      } else {
        isExpanded = modelTheme.toggle_components_mobile;
      }
    }
  } else if (widthSize > 500 && widthSize != null) {
    //DESKTOP
    if (modelTheme.toggle_components_desktop) {
      if (!completed.includes(groupType)) {
        isExpanded = modelTheme.toggle_components_desktop;
      }
    } else {
      if (completed.includes(groupType)) {
        isExpanded = completed.includes(groupType);
      } else {
        isExpanded = modelTheme.toggle_components_desktop;
      }
    }
  }

  const subGroups = allSubGroups
    .filter(
      (subGroup) =>
        subGroup.group_type === groupType && subGroup.option_sub_group_id !== 0 && subGroup.option_sub_group_id !== null,
    )
    .sort((a, b) => a?.option_sub_group_id - b?.option_sub_group_id);

  const groupOptions = options
    .filter((option) => option.group_type === groupType)
    .sort((a, b) => a?.option_id - b?.option_id);

  const [currentSelections, setCurrentSelections] = useQueryParam(
    'selections',
    JsonParam,
  );

  const currentOption = options.find((option) => {
    const variantId = currentSelections?.[groupType] || baseOption.variant_id;
    return option.variant_id === variantId;
  });

  const [selectedSubGroup, setSelectedSubGroup] = useState(null);

  const groupErrors = errors.filter(
    (error) =>
      error?.option?.group_type === groupType ||
      error?.target?.group_type === groupType,
  );

  // ---------- check for selected fans is match
  // const currentChassisFans = options?.find((option) => {
  //   const variantId =
  //     currentSelections?.['chassis_fans'] || baseOption?.variant_id;
  //   return option?.variant_id === variantId;
  // });
  // const currentChassisFansTags =
  //   pcModel?.modelOptionGroup
  //     .find((optionGroup) => optionGroup?.model_option_group_id === 7606)
  //     ?.options?.find(
  //       (chassisFans) => chassisFans?.option_id === currentChassisFans?.option_id,
  //     )?.component.tags ||
  //   pcModel?.modelOptionGroup
  //     .find((optionGroup) => optionGroup?.model_option_group_id === 7606)
  //     ?.options?.find((chassisFans) => chassisFans?.base === 1)?.component
  //     ?.tags;
  // const fangrillFans = currentChassisFansTags
  //   ?.split(', ')
  //   .find((attributes) => attributes.includes('attr:fangrill:is:'))
  //   ?.split('attr:fangrill:is:')[1];

  // const currentChassisFansDesign = options?.find((option) => {
  //   const variantId =
  //     currentSelections?.['custom_fan_design'] || baseOption?.variant_id;
  //   return option?.variant_id === variantId;
  // });
  // const currentChassisFansDesignTags =
  //   pcModel?.modelOptionGroup
  //     ?.find((optionGroup) => optionGroup?.model_option_group_id === 7609)
  //     ?.options?.find(
  //       (chassisFansDesign) =>
  //         chassisFansDesign?.option_id === currentChassisFansDesign?.option_id,
  //     )?.component?.tags ||
  //   pcModel?.modelOptionGroup
  //     .find((optionGroup) => optionGroup?.model_option_group_id === 7609)
  //     ?.options?.find((chassisFans) => chassisFans?.base === 1)?.component?.tags;
  // const fangrillDesign = currentChassisFansDesignTags
  //   ?.split(', ')
  //   .find((attributes) => attributes.includes('req:fangrill:min:'))
  //   ?.split('req:fangrill:min:')[1];

  // if (
  //   parseInt(fangrillFans) === 0 &&
  //   parseInt(fangrillDesign) > 0 &&
  //   (groupType === 'chassis_fans' || groupType === 'custom_fan_design')
  // ) {
  //   groupErrors.push({
  //     attr: 'fangrill',
  //     is_aggr: false,
  //     operator: 'is',
  //     option: currentChassisFansDesign,
  //     target: currentChassisFans,
  //     type: 'requirement',
  //   });
  // }

  // ------------

  const groupTitle = groupInfo?.optionGroup?.option_group_title;

  const handleResetClick = () => {
    setCurrentSelections({
      ...currentSelections,
      [groupType]: undefined,
    });
    setCompleted(undefined);
  };

  const handleSaveClick = () => {
    setCompleted(completed.concat(groupType));
    const topOfElement =
      document.getElementById(`group-type-${groupType}`).offsetTop - 100;
    window.scroll({ top: topOfElement, behavior: 'smooth' });
  };

  const handleExpandToggle = () => {
    if (widthSize <= 500 && widthSize != null) {
      //MOBILE
      if (modelTheme.toggle_components_mobile) {
        setCompleted(
          isExpanded
            ? completed.concat(groupType)
            : completed.filter((item) => item !== groupType),
        );
      } else {
        setCompleted(
          !isExpanded
            ? completed.concat(groupType)
            : completed.filter((item) => item !== groupType),
        );
      }
    } else if (widthSize > 500 && widthSize != null) {
      //DESKTOP
      if (modelTheme.toggle_components_desktop) {
        setCompleted(
          isExpanded
            ? completed.concat(groupType)
            : completed.filter((item) => item !== groupType),
        );
      } else {
        setCompleted(
          !isExpanded
            ? completed.concat(groupType)
            : completed.filter((item) => item !== groupType),
        );
      }
    }
  };

  return (
    <div
      id={`group-type-${groupType}`}
      className={classNames('options-group ', {
        error_group: groupErrors?.length,
        delayed_group: !groupErrors?.length && !currentOption?.in_stock,
        removed_item_group: !currentOption,
      })}
    >
      {groupErrors.length > 0 && (
        <div className='error_icon'>
          <Image
            draggable={false}
            src='https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-exclamation-blue.svg?v=1714039765'
            alt='Error'
            width={16}
            height={16}
          />
        </div>
      )}

      {groupErrors?.length === 0 && !currentOption?.in_stock && (
        <div className='error_icon'>
          <Image
            draggable={false}
            src='https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-exclamation-blue.svg?v=1714039765'
            alt='Error'
            width={16}
            height={16}
          />
        </div>
      )}

      {!currentOption && (
        <div className='error_icon'>
          <Image
            draggable={false}
            src='https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-exclamation-yellow.svg?v=1714040259'
            alt='Error'
            width={16}
            height={16}
          />
        </div>
      )}

      {modelTheme.toggle_design ? (
        <div
          className='heading-new'
          onClick={() => handleExpandToggle(groupType)}
          style={isExpanded ? { border: 0 } : { border: '2px solid #282828' }}
        >
          {!isExpanded && (
            <div
              className='expand-toggle'
              onClick={() => handleExpandToggle(groupType)}
            >
              <PcModelOptionImage
                src={currentOption?.image?.src}
                alt={currentOption?.image?.alt}
                width={120}
                height={120}
              />
            </div>
          )}

          <div className='heading-text'>
            <div className='heading-title'>{groupTitle}</div>
            <div className='heading-selected'>
              {currentOption?.title}
              {!isExpanded && <span className='edit-bracket'>[ edit ]</span>}
            </div>
            {!isExpanded && (
              <span className='edit-bracket-mobile'>[ edit ]</span>
            )}
            {!isExpanded ? (
              <div className='toggle-icon-con'>
                <img
                  draggable='false'
                  src={
                    'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/ChevronDown.svg?v=1714034100'
                  }
                  className='toggle-icon'
                />
              </div>
            ) : (
              <div className='toggle-icon-con'>
                <img
                  draggable='false'
                  src={
                    'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/ChevronUp.svg?v=1714034075'
                  }
                  className='toggle-icon'
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className='heading' onClick={() => handleExpandToggle(groupType)}>
          <div className='heading-text'>
            <div className='heading-title'>{groupTitle}</div>
            <div className='heading-selected'>{currentOption?.title}</div>
          </div>

          {!isExpanded && (
            <div
              className='expand-toggle'
              onClick={() => handleExpandToggle(groupType)}
            >
              <PcModelOptionImage
                src={currentOption?.image?.src}
                alt={currentOption?.image?.alt}
                width={120}
                height={120}
              />
            </div>
          )}
        </div>
      )}

      {isExpanded && (
        <div className='expanded'>
          {groupInfo.model_option_group_description && (
            <div className='description'>
              <div className='description-value'>
                {groupInfo?.model_option_group_description}
              </div>
            </div>
          )}

          {/* {groupInfo.group_note.length > 0 && (
            <div className="note">
              <div className="note-label">Note</div>
              <div className="note-value">
                {RichText.render(groupInfo?.group_note)}
              </div>
            </div>
          )} */}

          {groupErrors.length > 0 && (
            <ValidationAlert key={groupErrors} errors={groupErrors} />
          )}

          {currentOption && !currentOption?.in_stock && <PcModelDelayAlert />}

          {!currentOption && <PcModelDelayAlert type='removed' />}

          <div className='options'>
            <div>
              <div className='options-image'>
                <PcModelOptionImageWithModal
                  src={currentOption?.image?.src}
                  alt={currentOption?.image?.alt}
                  width={500}
                  height={500}
                  groupTitle={groupTitle}
                  options={groupOptions}
                  currentOption={currentOption}
                />
              </div>
            </div>

            <div className='options-list' data-groupListType={groupType}>
              <PcModelOptionsSubGroupTabs
                groupType={groupType}
                subGroups={subGroups}
                selectedSubGroup={selectedSubGroup}
                onTabClick={(subGroup) => setSelectedSubGroup(subGroup)}
              />

              <PcModelOptionsSubGroupLists
                groupType={groupType}
                subGroups={subGroups}
                selectedSubGroup={selectedSubGroup}
                options={groupOptions}
              />
            </div>
          </div>

          <div className='actions'>
            {/* <button
              type="button"
              className="button--link actions-reset"
              onClick={handleResetClick}
            >
              Reset to base
            </button> */}

            <button
              className='collapse'
              type='button'
              onClick={handleSaveClick}
            >
              COLLAPSE
              <div className='saveIcon'>
                <Image
                  draggable={false}
                  src='https://cdn.shopify.com/s/files/1/0637/0407/2436/files/ChevronUpDouble.svg?v=1714040296'
                  alt='save'
                  width={24}
                  height={24}
                />
              </div>
            </button>
          </div>
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

PcModelOptionsGroup.propTypes = {
  groupType: PropTypes.string.isRequired,
};

export default PcModelOptionsGroup;
